import { DELETE_ROLE, DELETE_ROLE_ERROR, DELETE_ROLE_SUCCESS, FETCH_ALL_ROLES, FETCH_ALL_ROLES_ERROR, FETCH_ALL_ROLES_SUCCESS, FETCH_ONE_ROLE, FETCH_ONE_ROLE_ERROR, FETCH_ONE_ROLE_SUCCESS, SAVE_ROLE, SAVE_ROLE_ERROR, SAVE_ROLE_SUCCESS } from "../constants/ActionTypes";

const initialState = {
  roles: [],
  error: null,
  loading: false,
  role: null
}

export default function rolesReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_ALL_ROLES:
    case SAVE_ROLE:
    case DELETE_ROLE:
    case FETCH_ONE_ROLE:
      return {
        ...state,
        loading: true
      }
    case FETCH_ALL_ROLES_SUCCESS:
      return {
        ...state,
        loading: false,
        roles: action.payload
      }
    case DELETE_ROLE_SUCCESS:
      return {
        ...state,
        loading: false,
        roles: state.roles.filter(role => role.role_id !== action.payload)
      }
    case FETCH_ONE_ROLE_SUCCESS:
      return {
        ...state,
        loading: false,
        role: action.payload
      }
    case SAVE_ROLE_SUCCESS:
      return {
        ...state,
        loading: false
      }
    case FETCH_ALL_ROLES_ERROR:
    case SAVE_ROLE_ERROR:
    case DELETE_ROLE_ERROR:
    case FETCH_ONE_ROLE_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload
      }
    default:
      return state;
  }
} 